module.exports = __webpack_public_path__ + "static/media/ramsi.83787f2d.jpg";